module.exports = __webpack_public_path__ + "media/contact/thankyou_line-2433ae74.png";